<script>
  import {onMount} from 'svelte'
  import gpsPosition from './stores/DevicePositionStore.js';
  import PositionLogEntry from './PositionLogEntry.svelte';
  export let device;

</script>


{#await gpsPosition.getLatestOne(device.appId, device.deviceEui, 10)}
  <!-- <p>Fetching positions...</p> -->
{:then positions}
  {#each positions as position}
    <PositionLogEntry {position} {device} on:elementAction/>
  {/each}
  <p class="is-size-7">Viewing the 10 most recent positions. Please refer to our documentation on how to access additional log entries via API.</p>
{:catch error}
  <p>{error}</p>
{/await}
  


